import { render } from "./BrazilPage.vue?vue&type=template&id=e0637166&scoped=true"
import script from "./BrazilPage.vue?vue&type=script&lang=js"
export * from "./BrazilPage.vue?vue&type=script&lang=js"

import "./BrazilPage.vue?vue&type=style&index=0&id=e0637166&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0637166"]])

export default __exports__